export default __webpack_public_path__ + "static/media/googleAnalyticsLogo@2x.76c07e74.png";